import firebase from "firebase/app"

var firebaseConfig = {
    apiKey: "AIzaSyDSMV7cFIyw6uVY3epEppggX4Ulp3L7IUU",
    authDomain: "expense-tracker-39166.firebaseapp.com",
    projectId: "expense-tracker-39166",
    storageBucket: "expense-tracker-39166.appspot.com",
    messagingSenderId: "560464578289",
    appId: "1:560464578289:web:3a5f07cce9d52981e98b50",
    measurementId: "G-56CE8HY1CD"
};

firebase.initializeApp(firebaseConfig);
